import React from 'react';
import { Box } from '@mui/material';
import CIHAChartsContainer from '../Common/CIHAChartsContainer';
import EstablishmentLocationWrapper from './index';

const EstablishmentLocation = () => {
    return (
        <Box>
            <Box className="content">
                <CIHAChartsContainer
                    title={'Estabelecimento / Série Localização'}
                    className="services-container-dashboards"
                >
                    <EstablishmentLocationWrapper />
                </CIHAChartsContainer>
            </Box>
        </Box>
    );
};

export default EstablishmentLocation;
